<div class="modal-header">
  <h4 class="modal-title">
    {{ config.title }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p class="mb-0">{{ config.message }}</p>
</div>

<div class="modal-footer">
  <dfm-button
    color="secondary"
    size="sm"
    (click)="onCancel()">
    {{ config.cancelText }}
  </dfm-button>

  <dfm-button
    color="primary"
    size="sm"
    (click)="onConfirm()">
    {{ config.confirmText }}
  </dfm-button>
</div>
